import { Services } from '@sigma-frontend-libs/commons'

import { sizes } from '@/utils'

import tag from '@/components/tag'

const baseClass = `${Services.sendernames}-form-requisites-card`

function renderTitle(h) {
  if (this.title) {
    return h(
      'div',
      {
        class: `${baseClass}__title`
      },
      [ this.title ]
    )
  }
}
function renderLabel(h) {
  if (this.label) {
    return h(
      tag,
      {
        props: {
          label: this.label,
          size: sizes.small
        }
      }
    )
  }
}
function renderHeader(h) {
  if (this.title || this.label) {
    return h(
      'div',
      {
        class: `${baseClass}__header`
      },
      [
        renderTitle.call(this, h),
        renderLabel.call(this, h)
      ]
    )
  }
}

function renderRowLabel(h, label) {
  return h(
    'div',
    {
      class: `${baseClass}__label`
    },
    [ label ]
  )
}
function renderRowValue(h, value) {
  return h(
    'div',
    {
      class: `${baseClass}__value`
    },
    [ value ]
  )
}
function renderItem(h, item) {
  return h(
    'div',
    {
      key: item.key,
      class: `${baseClass}__item`
    },
    [
      renderRowLabel.call(this, h, item.label),
      renderRowValue.call(this, h, item.value)
    ]
  )
}
function renderBody(h) {
  return h(
    'div',
    {
      class: `${baseClass}__body`
    },
    [
      this.items.map(item => {
        return renderItem.call(this, h, item)
      })
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: baseClass
    },
    [
      renderHeader.call(this, h),
      renderBody.call(this, h)
    ]
  )
}
